import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { AuthService } from '@shared/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../encryption.service";
export class ApiService {
    constructor(http, encryptionProviderService) {
        this.http = http;
        this.encryptionProviderService = encryptionProviderService;
        this.getData = (endPoint) => {
            const headers = this.getHeaders();
            return Observable.create((observer) => {
                this.http
                    .get(endPoint, { headers })
                    .pipe(timeout(60000))
                    .subscribe((response) => {
                    if (response['eData']) {
                        response = JSON.parse(this.encryptionProviderService.decryptData(response['eData']));
                    }
                    if (response.status === 0) {
                        observer.next(response);
                    }
                    else {
                        observer.error(response);
                    }
                }, (error) => {
                    observer.error(error);
                }, () => observer.complete());
            });
        };
    }
    postData(endPoint, data) {
        const headers = this.getHeaders();
        return Observable.create((observer) => {
            this.http
                .post(endPoint, data, { headers })
                .pipe(timeout(60000))
                .subscribe((response) => {
                if (response['eData']) {
                    response = JSON.parse(this.encryptionProviderService.decryptData(response['eData']));
                }
                if (response.status === 0) {
                    observer.next(response);
                }
                else {
                    observer.error(response);
                }
            }, (error) => {
                observer.error(error);
            }, () => observer.complete());
        });
    }
    getHeaders() {
        const headers = {}; // set session token if logged in user
        if (AuthService.isLoggedIn()) {
            headers['session-token'] = AuthService.getToken();
        }
        return headers;
    }
}
ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EncryptionProviderService)); }, token: ApiService, providedIn: "root" });
